/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import { Modal, Typography } from "antd";
import EllipsisText from "components/_storybooks/EllipsisText";
import StateSwitch from "components/StateSwitch";
import useDebounce from "hooks/useDebounce";
import { useEffect, useState } from "react";
import { buildQueryString, getQuery, notify } from "utils/helperFuncs";
import moment from "moment";
import { useMutation, useQuery } from "@apollo/client";
import { DISABLE_CONTRACT } from "graphql/contract/mutation";
import { GET_CONTRACTS } from "graphql/contract/query";
import { useGetSellerDetail } from "hooks/seller";
import FilterMenu from "./components/FilterMenu";
import FilterSellerContract from "./components/FilterSellerContract";

const CONTRACT_TYPE_OPTIONS = [
  { label: "Hợp đồng nguyên tắc", value: "FRAMEWORK_AGREEMENT" },
  { label: "Hợp đồng mua bán", value: "PURCHASE_AGREEMENT" },
];

const CONTRACT_STATUS_OPTIONS = [
  { label: "Còn hiệu lực", value: "ACTIVE" },
  { label: "Hết hạn", value: "EXPIRED" },
  { label: "Vô hiệu hóa", value: "DISABLED" },
];

export { CONTRACT_TYPE_OPTIONS, CONTRACT_STATUS_OPTIONS };

export default function useList() {
  const GET_QUERY = getQuery();
  const toArray = (value) => {
    if (Array.isArray(value)) return value;
    if (value === undefined || value === null || value === "") return [];
    return [value];
  };

  const [params, setParams] = useState(() => {
    return {
      filters: {
        keyword: GET_QUERY?.keyword || "",
        sellerID: GET_QUERY?.sellerID || undefined,
        statuses: toArray(GET_QUERY?.statuses),
        types: toArray(GET_QUERY?.types),
        startDate: {
          from: GET_QUERY?.startDateFrom || GET_QUERY?.from || undefined,
          to: GET_QUERY?.startDateTo || GET_QUERY?.to || undefined,
        },
        endDate: {
          from: GET_QUERY?.endDateFrom || undefined,
          to: GET_QUERY?.endDateTo || undefined,
        },
      },
      pagination: {
        limit: Number(GET_QUERY?.limit) || 10,
        offset: Number(GET_QUERY?.offset) || 0,
      },
      sorts: [],
    };
  });

  const isEmptyFilterValue = (value) => {
    if (value === "" || value === null || value === undefined) return true;
    if (Array.isArray(value) && value.length === 0) return true;
    if (typeof value === "object") {
      return Object.values(value).every((item) => item === undefined || item === null || item === "");
    }
    return false;
  };

  const [filterTags, setFilterTags] = useState([]);

  const onFilter = (key, value) => {
    setParams((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        [key]: value,
      },
      pagination: {
        ...prev.pagination,
        offset: 0,
      },
    }));
  };

  const [disableContract, { loading: loadingDisableContract }] = useMutation(DISABLE_CONTRACT);

  const handleDisableContract = async (id) => {
    try {
      await disableContract({ variables: { id } });
      notify.success({ message: "Vô hiệu hóa hợp đồng thành công" });
      refetch();
    } catch (error) {
      notify.error({ message: error?.message || "Có lỗi xảy ra khi vô hiệu hóa hợp đồng" });
    }
  };

  const { data, loading, refetch } = useQuery(GET_CONTRACTS, {
    variables: {
      filters: Object.fromEntries(
        Object.entries({
          sellerID: params.filters.sellerID,
          keyword: params.filters.keyword,
          types: params.filters.types,
          statuses: params.filters.statuses,
          startDate: params.filters.startDate,
          endDate: params.filters.endDate,
        }).filter(([_, value]) => !isEmptyFilterValue(value))
      ),
      pagination: {
        limit: params.pagination.limit,
        offset: params.pagination.offset,
      },
    },
    fetchPolicy: "cache-and-network",
  });

  const dataSource = data?.contractQuery?.list?.contracts || [];
  const total = data?.contractQuery?.list?.paginationData?.total || 0;

  const { data: sellerDetail } = useGetSellerDetail({ id: params?.filters?.sellerID });
  const sellerFilterOptions = params?.filters?.sellerID
    ? [{ value: params.filters.sellerID, label: sellerDetail?.fullName || params.filters.sellerID }]
    : [];

  const handleRemoveFilterTag = (key) => {
    const resetValueByKey = {
      keyword: "",
      sellerID: undefined,
      statuses: [],
      types: [],
      startDate: { from: undefined, to: undefined },
      endDate: { from: undefined, to: undefined },
    };

    const newFilters = {
      ...params.filters,
      [key]: resetValueByKey[key],
    };

    setParams((prev) => ({
      ...prev,
      pagination: { offset: 0, limit: 10 },
      filters: newFilters,
    }));

    buildQueryString({
      params: {
        keyword: newFilters.keyword,
        sellerID: newFilters.sellerID,
        statuses: newFilters.statuses,
        types: newFilters.types,
        startDateFrom: newFilters?.startDate?.from,
        startDateTo: newFilters?.startDate?.to,
        endDateFrom: newFilters?.endDate?.from,
        endDateTo: newFilters?.endDate?.to,
        offset: 0,
        limit: 10,
      },
    });
  };

  const handleSort = (by) => {
    if (params.sorts[0]?.type === "ASC") {
      const newParams = {
        ...params,
        sorts: [{ by: by, type: "DESC" }],
      };
      setParams(newParams);
    } else {
      const newParams = {
        ...params,
        sorts: [{ by: by, type: "ASC" }],
      };
      setParams(newParams);
    }
  };

  const columns = [
    {
      title: "STT",
      width: 60,
      align: "center",
      render: (_, __, index) => params.pagination.offset + index + 1,
    },
    {
      title: <span>MÃ HỢP ĐỒNG</span>,
      key: "actionEdit",
      render: (_, record) => {
        return <EllipsisText isLink={true} title={record.code} link={`contract/detail/${record.id}`} strong />;
      },
      align: "center",
    },
    {
      title: (
        <Typography.Text className="title-table" onClick={() => handleSort("CREATED_AT")} style={{ color: "#5B6673" }}>
          ĐẠI LÝ
        </Typography.Text>
      ),
      filterDropdown: (
        <FilterSellerContract
          onFilter={(value) => onFilter("sellerID", value)}
          defaultValue={params?.filters?.sellerID}
        />
      ),
      render: (_, record) => {
        return (
          <Typography.Link
            strong
            onClick={(e) => {
              e.preventDefault();
              window.open(`/seller/detail/${record.sellerID || record.seller?.id}`, "_blank");
            }}
          >
            {record?.seller?.fullName || "-"}
          </Typography.Link>
        );
      },
      align: "start",
    },
    {
      title: <span>LOẠI HỢP ĐỒNG</span>,
      align: "center",
      filterDropdown: (
        <FilterMenu
          onFilter={(value) => onFilter("types", value)}
          type="checkbox"
          searchable
          options={CONTRACT_TYPE_OPTIONS}
          defaultValue={params?.filters?.types}
          params={{ filters: { ownerType: params?.filters?.types } }}
        />
      ),
      render: (_, record) => {
        const typeMap = {
          FRAMEWORK_AGREEMENT: "Hợp đồng nguyên tắc",
          PURCHASE_AGREEMENT: "Hợp đồng mua bán",
        };
        return <Typography.Text>{typeMap[record.type] || record.type}</Typography.Text>;
      },
    },
    {
      title: <span>NGÀY KÝ</span>,
      align: "center",
      render: (_, record) => {
        return (
          <Typography.Text className="text-hidden-two">
            {record.startDate ? moment(record.startDate).format("DD/MM/YYYY") : "-"}
          </Typography.Text>
        );
      },
    },
    {
      title: <span>HẾT HẠN</span>,
      align: "center",
      render: (_, record) => {
        return (
          <Typography.Text className="text-hidden-two">
            {record.endDate ? moment(record.endDate).format("DD/MM/YYYY") : "-"}
          </Typography.Text>
        );
      },
    },
    {
      title: <span>TRẠNG THÁI</span>,
      filterDropdown: (
        <FilterMenu
          onFilter={(value) => onFilter("statuses", value)}
          type="checkbox"
          searchable
          options={CONTRACT_STATUS_OPTIONS}
          defaultValue={params?.filters?.statuses}
          params={{ filters: { ownerType: params?.filters?.statuses } }}
        />
      ),
      render: (_, record) => {
        const statusMap = {
          ACTIVE: { text: "Còn hiệu lực", color: "#00AB78", bgColor: "#EDF9F0" },
          EXPIRED: { text: "Hết hạn", color: "#faad14", bgColor: "rgba(255, 197, 61, 0.15)" },
          DISABLED: { text: "Vô hiệu hóa", color: "#cf1322", bgColor: "rgba(255, 77, 79, 0.15)" },
        };
        const statusInfo = statusMap[record.status] || { text: record.status, color: "#5B6673", bgColor: "#F2F4F7" };

        return (
          <span
            style={{
              padding: "4px 12px",
              borderRadius: "16px",
              backgroundColor: statusInfo.bgColor,
              border: `1px solid ${statusInfo.color}`,
              color: statusInfo.color,
              fontSize: "12px",
              fontWeight: 500,
            }}
          >
            {statusInfo.text}
          </span>
        );
      },
      align: "center",
    },
    {
      title: <span>NGƯỜI LẬP HỢP ĐỒNG</span>,
      render: (_, record) => {
        return (
          <Typography.Text className="text-hidden-two">
            {record.drafterBy?.fullname || record.drafterBy?.fullname || "-"}
          </Typography.Text>
        );
      },
      align: "center",
    },
    {
      title: <span>THAO TÁC</span>,
      render: (_, record) => {
        const isActive = record.status === "ACTIVE";

        return (
          <StateSwitch
            checked={isActive}
            loading={loadingDisableContract}
            disabled={!isActive}
            style={!isActive ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
            onChange={(checked) => {
              if (!checked && isActive) {
                Modal.confirm({
                  title: "Bạn có chắc chắn muốn vô hiệu hóa hợp đồng không?",
                  okText: "Xác nhận",
                  cancelText: "Hủy",
                  onOk: () => handleDisableContract(record.id),
                });
              }
            }}
          />
        );
      },
      align: "center",
    },
  ];

  const handleChangeTable = (pagination) => {
    const { current, pageSize } = pagination;
    const offset = (current - 1) * pageSize;
    let newParams = {
      ...params,
      pagination: { limit: pageSize, offset },
    };
    setParams(newParams);
    buildQueryString({
      params: {
        keyword: newParams.filters.keyword,
        sellerID: newParams.filters.sellerID,
        statuses: newParams.filters.statuses,
        types: newParams.filters.types,
        startDateFrom: newParams?.filters?.startDate?.from,
        startDateTo: newParams?.filters?.startDate?.to,
        endDateFrom: newParams?.filters?.endDate?.from,
        endDateTo: newParams?.filters?.endDate?.to,
        offset,
        limit: pageSize,
      },
    });
  };

  useEffect(() => {
    buildQueryString({
      params: {
        offset: params.pagination.offset,
        limit: params.pagination.limit,
        keyword: params.filters.keyword,
        sellerID: params.filters.sellerID,
        statuses: params.filters.statuses,
        types: params.filters.types,
        startDateFrom: params?.filters?.startDate?.from,
        startDateTo: params?.filters?.startDate?.to,
        endDateFrom: params?.filters?.endDate?.from,
        endDateTo: params?.filters?.endDate?.to,
      },
    });
  }, [params]);

  const [searchTerm, setSearchTerm] = useState(GET_QUERY?.keyword || "");

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const debouncedValue = useDebounce(searchTerm, 500);

  useEffect(() => {
    setParams((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        keyword: debouncedValue?.trim(),
      },
      pagination: {
        ...prev.pagination,
        offset: 0,
      },
    }));
  }, [debouncedValue]);

  useEffect(() => {
    setSearchTerm(params?.filters?.keyword || "");
  }, [params?.filters?.keyword]);

  return {
    params,
    handleSearch,
    handleRemoveFilterTag,
    filterTags,
    setFilterTags,
    setParams,
    searchTerm,
    columns,
    handleChangeTable,
    dataSource,
    loading,
    total,
    refetch,
    optionOwnerType: CONTRACT_TYPE_OPTIONS,
    optionStatus: CONTRACT_STATUS_OPTIONS,
    sellerFilterOptions,
  };
}
